// extracted by mini-css-extract-plugin
export default {"overlayWrapper":"UserProfile_overlayWrapper__NcCP1","viewBox":"UserProfile_viewBox__xPNbr"};